var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hit_delete',{staticStyle:{"color":"red !important"},attrs:{"icon":true,"callback":function(){ _vm.remove_board() }}},[_vm._v(_vm._s(_vm.$t("message.allDataWillBeDeleted")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }